import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { KeyValueModel } from '@models/common';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoDialogModule } from '@shared/modules';

export interface RoleOrderingDialogData {
  userName: string;
  roles: KeyValueModel<number, string>[];
}

@Component({
  selector: 'cipo-role-ordering-dialog',
  imports: [CipoDialogModule, CipoDialogHeaderComponent, DragDropModule],
  templateUrl: './role-ordering-dialog.component.html',
  styleUrls: ['./role-ordering-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleOrderingDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RoleOrderingDialogComponent, KeyValueModel<number, string>[]>);
  private readonly data = inject<RoleOrderingDialogData>(MAT_DIALOG_DATA);

  readonly userName = this.data.userName;
  readonly roles = signal(this.data.roles);

  drop(event: CdkDragDrop<KeyValueModel<number, string>[]>): void {
    this.roles.update(roles => {
      const reorderedRoles = [...roles];
      moveItemInArray(reorderedRoles, event.previousIndex, event.currentIndex);
      return reorderedRoles;
    });
  }

  save(): void {
    this.dialogRef.close(this.roles());
  }
}
